var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.384 11.987a.993.993 0 01-.707-.293l-4.243-4.242a1 1 0 010-1.414l2.122-2.121a3.07 3.07 0 014.242 0l1.414 1.414a3 3 0 010 4.242l-2.122 2.121a.993.993 0 01-.706.293zm-2.829-5.242l2.829 2.828L26.8 8.159a1 1 0 000-1.414l-1.416-1.414a1.023 1.023 0 00-1.414 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 22.221a2 2 0 01-1.933-2.487l.875-3.5a3.02 3.02 0 01.788-1.393l8.8-8.8a1 1 0 011.414 0l4.243 4.242a1 1 0 010 1.414l-8.8 8.8a3 3 0 01-1.393.79l-3.5.875a2.027 2.027 0 01-.494.059zm3.752-1.907zm5.489-12.155l-8.094 8.093a1 1 0 00-.262.465l-.876 3.5 3.5-.876a1 1 0 00.464-.263l8.094-8.094z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29H8a5.006 5.006 0 01-5-5V10a5.006 5.006 0 015-5h9.64a1 1 0 010 2H8a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3v-9.39a1 1 0 012 0V24a5.006 5.006 0 01-5 5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default ForwardRef;